import { render, staticRenderFns } from "./ConsumablesList.vue?vue&type=template&id=64bf4769&"
import script from "./ConsumablesList.vue?vue&type=script&lang=js&"
export * from "./ConsumablesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports